import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon, observable } from 'legacy-packages/ft-cb';
import './WarningNotification.scss';

const NAV_HEIGHT = 40; //pixels
const NOTIF_CLOSE_GAP = 3500; //seconds

const WarningNotification = (props) => {
  const playerHasNav = document.querySelector('.mobile-tabs-root');
  const { canShowWarning } = props;
  const [showNotification, setShowNotification] = useState(canShowWarning);
  let defaultNotifLocation;
  if (
    playerHasNav &&
    playerHasNav.parentElement.classList.contains('is-sticky')
  ) {
    defaultNotifLocation = 'below-nav';
  } else {
    defaultNotifLocation = 'top';
  }
  const [notifLocation, setNotifLocation] = useState(defaultNotifLocation);
  let timeoutId;

  useEffect(() => {
    if (defaultNotifLocation !== notifLocation) {
      setNotifLocation(defaultNotifLocation);
    }
  }, [defaultNotifLocation]);

  /**
   * Notification positions
   * - top: position-top
   * - below-nav: position-below-nav
   * */

  const onNotificationClick = () => {
    setShowNotification(false);
  };

  useEffect(() => {
    const onScrollEvent = () => {
      let scrollPosition =
        'pageYOffset' in window ? window.pageYOffset : document.body.scrollTop;
      let location;
      if (scrollPosition > NAV_HEIGHT && notifLocation !== 'top') {
        location = playerHasNav ? 'below-nav' : 'top';
      } else if (
        scrollPosition > NAV_HEIGHT &&
        notifLocation !== 'below-nav' &&
        playerHasNav
      ) {
        location = 'below-nav';
      } else if (scrollPosition === 0) {
        location = 'top';
      }

      if (location) {
        setNotifLocation(location);
      }
    };

    if (canShowWarning) {
      window.addEventListener('scroll', onScrollEvent);
      setShowNotification(true);
      timeoutId = setTimeout(() => {
        setShowNotification(false);
      }, NOTIF_CLOSE_GAP);

      observable.updateObservable({
        add: {
          timeouts: timeoutId,
        },
      });
    }

    return () => {
      window.removeEventListener('scroll', onScrollEvent);
      if (timeoutId) {
        clearTimeout(timeoutId);
        observable.updateObservable({
          remove: {
            timeouts: timeoutId,
          },
        });
      }
    };
  }, [canShowWarning]);

  if (!showNotification) return null;

  return (
    <div
      className={cn('Warning-notification', {
        [`position-${notifLocation}`]: notifLocation !== null,
      })}
    >
      <div className="Warning-notification--message">
        Less than 5 minutes remaining
      </div>
      <div
        className="Warning-notification--close"
        role="button"
        tabIndex={0}
        onClick={onNotificationClick}
      >
        <Icon
          aria-label="Hide timer warning"
          name="xmark"
          width={16}
          height={16}
        />
      </div>
    </div>
  );
};

WarningNotification.propTypes = {
  canShowWarning: PropTypes.bool,
};

WarningNotification.defaultProps = {
  canShowWarning: false,
};

function areEqual(prevProps, nextProps) {
  return prevProps.canShowWarning === nextProps.canShowWarning;
}
const MemoizedWarningNotification = React.memo(WarningNotification, areEqual);

export default MemoizedWarningNotification;
